import firebase from 'firebase/app';
import React, { useCallback } from 'react';
import { FaTwitterSquare as BrandIcon } from 'react-icons/fa';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  button: {
    '&:hover': { background: '#1781C3' },
    background: '#1DA1F2',
    borderRadius: 4,
    color: '#FFF',
    composes: [
      'flex-columns',
      'flex-center',
      'items-center',
      'p12',
      'my6',
      'is-full-width',
    ],
    transition: 'background 0.3s',
  },
  icon: {
    composes: ['mr6', 'fs16'],
  },
  label: {
    composes: ['text-left'],
    width: 75,
  },
});

const TwitterButtonComponent = React.memo(() => {
  const classes = useStyles();

  const signinHandler = useCallback(() => {
    const provider = new firebase.auth.TwitterAuthProvider();
    firebase.auth().signInWithRedirect(provider);
  }, []);

  return (
    <button className={classes.button} type="button" onClick={signinHandler}>
      <BrandIcon className={classes.icon} />
      <span className={classes.label}>Twitter</span>
    </button>
  );
});

TwitterButtonComponent.displayName = 'TwitterButtonComponent';

export default TwitterButtonComponent;
